import React from 'react';
import ReactDOM from 'react-dom';
import { MDSContextProvider } from '@metservice/use-mds';

import { PlatStageProvider } from '@mono/use-plat-stage';
import { IStage } from '@mono/types/src';

import './index.css';
import App from './App';
import * as serviceWorker from './serviceWorker';
import 'antd/dist/antd.css';
import { UserTrackingContextProvider } from '@mono/user-tracking';

declare const _stage: IStage;

ReactDOM.render(
    <PlatStageProvider stage={_stage}>
        <UserTrackingContextProvider app='dashboard_app'>
            <MDSContextProvider>
                <App />
            </MDSContextProvider>
        </UserTrackingContextProvider>
    </PlatStageProvider>,
    document.getElementById('root')
);

// If you want your app to work offline and load faster, you can change
// unregister() to register() below. Note this comes with some pitfalls.
// Learn more about service workers: https://bit.ly/CRA-PWA
serviceWorker.unregister();
